import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { pay } from "../../../../Service/payment";
import StepProgress from "./steprogress";
import { CommonImages, LoginImages } from "../../../../reusableUI/images";
import { getPaymentLookup } from "../../../../Service/lookup";
const packages = [
  {
    title: "Basic Partnership Plan",
    price: "₹ 30,000",
    features: [
      "Access to Verified Patient Bookings",
      "Priority Listing in the Ceviliyar App",
      "Dedicated Nurse Dashboard for Schedule Management",
      "Integrated Payment Handling & Fast Payouts",
      "Profile Promotion & Marketing Support",
    ],
    highlighted: false,
  },
];

const Membership = () => {
  const location = useLocation();
  const userData = location.state?.userData;
  const [amount, setAmount] = useState(30000);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentURL, setPaymentURL] = useState("");

  useEffect(() => {
    getAmount();
  }, []);

  const findValue = (list, type) => {
    const match = list.find((item) => item.type === type);
    return match?.value || 0;
  };

  const getAmount = async () => {
    const res = await getPaymentLookup();
    console.log(res.data);

    if (res.error === false && Array.isArray(res.data)) {
      const registrationFee = findValue(res.data, "hospital registration");
      setAmount(registrationFee);
    }
  };
  // console.log(amount);

  const payment = async () => {
    try {
      let data = {
        amount: amount,
        reason: "One time registration fee",
        name: userData?.basicInfo?.name,
        // phone: loginNumber,
        url: "http://localhost:3000/ratefix",
        notes: {
          mode: "hospital registration fee",
          userID: userData._id,
        },
      };

      // console.log(data);

      let paymentIntent = await pay(data);

      if (paymentIntent.error === false && paymentIntent.data?.short_url) {
        secureLocalStorage.setItem("membershipPaid", true);
        window.location.href = paymentIntent.data.short_url;
      } else {
        console.log(
          "Payment initiation failed:",
          paymentIntent.message || "Unknown error"
        );
      }
    } catch (error) {
      console.log("Payment error:", error);
    }
  };

  return (
    <div className="min-h-screen bg-[#4951EC] flex flex-col items-center justify-center p-6 ">
      <StepProgress currentStep={1} />
      <div className="bg-white w-[75%] rounded-sm shadow-xl p-8">
        <img
          src={CommonImages.CevIcon}
          alt="Logo"
          className="h-[34px] w-[130px] mb-6 mx-auto"
        />
        <h2 className="text-[22px] font-poppins font-semibold text-center text-gray-800 mb-5 font-poppins">
          Hospital Registration Fee
        </h2>
        <p className="text-center text-gray-500 mb-8 text-sm font-poppins">
          This is a one time fee for partershiping with Ceviliyar.
        </p>

        {packages.map((pack, index) => (
          <div
            key={index}
            className={`w-[35%] h-[55vh] mx-auto rounded-lg p-6 shadow-md text-center transition ${
              pack.highlighted
                ? "bg-gradient-to-b from-blue-500 to-blue-700 text-white"
                : "bg-gray-50"
            }`}
          >
            <h3 className="text-xl font-semibold mb-2 font-poppins">
              {pack.title}
            </h3>
            <p className="text-3xl font-semibold mb-4 font-poppins">
              ₹{amount}
            </p>
            <ul className="text-sm space-y-2 mb-10">
              {pack.features.map((feature, i) => (
                <li
                  key={i}
                  className={
                    pack.highlighted
                      ? ""
                      : "text-[12px] font-poppins text-gray-600"
                  }
                >
                  • {feature}
                </li>
              ))}
            </ul>
            <button
              onClick={payment}
              className={`px-4 py-1.5 font-poppins bg-custom-gradient rounded-md text-[13px] font-medium ${
                pack.highlighted
                  ? "bg-white text-blue-700 font-poppins hover:bg-gray-100"
                  : "bg-[#4951EC] text-white  font-poppins hover:bg-blue-600"
              }`}
            >
              Pay Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Membership;
